<template>
	<main class="main-wrapper flex-grow-1 bg-documentGray">
		<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m bg-white fix-header-title d-flex align-items-center justify-content-center">{{this.$t('784')}}</div>
		<div class="divider"></div>
		<!-- subtabs -->
			<TopAppBarLeaderListTab></TopAppBarLeaderListTab>
			<div v-if="campaignData && campaignData.dynamicLink && campaignData.locationValue === null">
				<a :href="campaignData.dynamicLink.shortLink" target="_blank">
						<img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
				</a>
		</div>
		<div class="container container--narrow pdt-30">
				<div class="mdc-card  mgb-24 pdt-16 pdb-16" v-if="myStatus=='RANKING'">
						<div class="d-grid-3" >
								<div class="justify-self-end align-self-center">
										<div class="d-flex flex-column align-items-center">
												<div class="t-color-bodyGrayA t-body3 font-r t-center pdt-14">{{$t('785')}}</div>
												<div class="t-headline5 t-center l-spacing66 pdt-6 font-b">{{ mine.rank}}</div>
										</div>
								</div>
								<div>
										<div class="d-flex flex-column align-items-center align-items-center">
										<span v-if="mine.profile && mine.profile.file && mine.profile.file.resourceUri" class="level-icon mgt-1 mgb-8 d-flex justify-content-center align-items-center t-color-white font-m mgx-auto"
          >
			<UserImgProfile :allData="mine" :data="mine" :className="'w-60 h-60'" :size="'l'" />
          </span>
          <span v-else
            class="level-icon mgt-1 mgb-8 d-flex justify-content-center align-items-center t-color-white font-m mgx-auto w-60 user-name-profile" v-html="firstCharOfNames" :style="bgColorOfName"
          >
          </span>
												<div class="d-flex align-items-baseline"><span
																class="t-color-bodyGrayA t-helper font-r pdr-4">{{$t('786')}}</span><span
																class="t-subtitle3 font-m">{{ mine.level }}</span></div>
										</div>
								</div>
								<div class="justify-self-start align-self-center">
										<div class="d-flex flex-column align-items-center">
												<div class="t-color-bodyGrayA t-body3 font-r t-center pdt-14">{{$t('787')}}</div>
												<div class="t-headline5 t-center l-spacing66 pdt-6 font-b">{{ mine.point}}</div>
										</div>
								</div>
						</div>
				</div>
		<div class="mdc-card  mgb-24 pdt-23 pdb-23" v-if="myStatus=='STORE'">
			<div class="d-grid-3-leader">
				<div class="justify-self align-self-center">
					<div class="d-flex flex-column align-items-center">
							<div class="t-color-bodyGrayA t-body3 font-r t-center pdt-9">{{$t('1285')}}</div>
							<div class="t-headline5 t-center l-spacing66 pdt-12 font-b">{{ mine.rank}}</div>
					</div>
				</div>
				<div class="seperator position-relative">
				</div>
				<div class="justify-self">
					<div class="d-flex flex-column align-items-center">
						<div class=" t-body3 font-m l-spacing48 t-center pdt-9">{{ storeName }}</div>
						<div class="t-headline5 t-center l-spacing66 pdt-12 d-flex align-items-center font-b">
							<img src="images/ic-credit.png" class="w-24 d-inline mgr-4" alt="">{{ mine.point }}</div>
					</div>
				</div>
			</div>
		</div>
				<div class="mdc-card  mgb-50 pdt-8 pdb-6">
					<div v-for="(leaderList, index) in listData" :key="index" :class="listData.length == index+1 ? '' :'leader-list'">
						<ListItem :leaderList="leaderList" :myStatus="myStatus"></ListItem>
					</div>
					<infinite-loading  @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
						<div slot="no-more" class=""> </div>
						<div slot="no-results" class=""></div>
				</infinite-loading>
				</div>
		</div>
</main>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import memberApi from "@/api/memberApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoData.vue";
import InfiniteLoading from "vue-infinite-loading";
import TopAppBarLeaderListTab from "../TopAppBarLeaderListTab.vue"

export default {
	components: {
    ListItem,
    NoData,
    InfiniteLoading,
    TopAppBarLeaderListTab,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue")
},

	data() {
		return {
			status: "",
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			mine: "",
			storeName:"",
			myStatus: "",
			infiniteId: +new Date(),
			firstCharOfNames : localStorage.getItem('firstChar'),
      		bgColorOfName : localStorage.getItem('bgColors'),
		};
	},

	computed: {},

	watch: {
		$route(to, from) {
			this.initData();
			this.myStatus = this.$route.query.status;
		},
	},

	mounted() {
		// 기본 파라미터 설정(set default parameter)
		if (!this.$route.query.status) {
			this.$router.push({ query: { status: "RANKING" } });
			this.myStatus = this.$route.query.status;
		} else {
			this.myStatus = this.$route.query.status;
		}
		 this.setMaterialUi()
	},

	methods: {
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1
		},
		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let responseData = null;
			let params = this.setParams();
			if (this.totalPages >= this.currentPage) {
				memberApi
					.leaderBoard(params)
					.then((response) => {
						responseData = response.data.data;
						if(params.status=='STORE') {
							this.mine = responseData.mine;
							this.storeName = responseData.mine.name;
						} else {
							this.mine = responseData.mine;
						}
						//console.log('responseData=>',responseData);
						this.listData = this.listData.concat(responseData.rankings);
						this.currentPage++;
						this.totalPages = responseData.totalPages;

						if (responseData.rankings.length) {
							$state.loaded();
						} else {
							$state.complete();
						}

						if (this.listData.length > 0) {
							this.isNoData = false;
						} else {
							this.isNoData = true;
						}
					})
					.catch((err) => {
						$state.error();
					});
			} else {
				$state.complete();
			}

			// 캠페인 테이터 API 호출(get campaign data)
			let locationType =
				this.$route.query.status === "LEARNING"
					? "LEARN_IN_PROGRESS_DEGREE"
					: "LEARN_COMPLETED_DEGREE";
			campaignApi
				.campaign({ locationType: locationType })
				.then((response) => {
					this.campaignData = response.data.data;
				})
				.catch((err) => {});
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				status: this.$route.query.status,
				name: "",
				category: "",
				page: this.currentPage,
				size: 10,
			};
			return params;
		},

		// 학습진행률 노출 상태 설정(set/toggle learning status graph)
		initProgressStatus(id) {
			_.map(this.listData, (o) => {
				o.id === id && o.progressViewStatus === false
					? (o.progressViewStatus = true)
					: (o.progressViewStatus = false);
			});
		},
		setMaterialUi() {
				const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
						let button = new MDCRipple.attachTo(el)
						return button
				})
		},
	},
	
};
</script>